/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EvaluationsScopeFilter } from './evaluationsScopeFilter';


export interface EvaluationsIncludeFilterItems { 
    relation?: EvaluationsIncludeFilterItems.RelationEnum;
    scope?: EvaluationsScopeFilter;
}
export namespace EvaluationsIncludeFilterItems {
    export type RelationEnum = 'evaluationPeriod' | 'user' | 'status' | 'surveys' | 'evaluationScores' | 'evaluationComments';
    export const RelationEnum = {
        EvaluationPeriod: 'evaluationPeriod' as RelationEnum,
        User: 'user' as RelationEnum,
        Status: 'status' as RelationEnum,
        Surveys: 'surveys' as RelationEnum,
        EvaluationScores: 'evaluationScores' as RelationEnum,
        EvaluationComments: 'evaluationComments' as RelationEnum
    };
}


